import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '../communication-config/communication-config.service';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsSigninService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private configService: ConfigService,
    private http: HttpClient
  ) {}

  checkSignIn() {
    if (this.configService.getOptions().useTestData === true) {
      return of('OK');
    } else {
      return this.http.get<string>(`${this.communicationConfigService.getApiUri()}/sign/check-sign-in`);
    }
  }
}
